export default {"src":"/_next/static/media/pay.1437fe31.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};